import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home';
import Login from '../views/Login';
import Comparison from '../views/Comparison';
import Ordering from '../views/Ordering';
import OrderingReport from '../views/OrderingReport';

import History from '../views/History';
import UpdatedProductsBarcodes from '../views/UpdatedProductsBarcodes';
import Lost from '../views/Lost';
/*
import PasswordReset from '../views/PasswordReset';
import PasswordResetConfirm from '../views/PasswordResetConfirm';
import Register from '../views/Register';
import VerifyEmail from '../views/VerifyEmail';
*/

import store from '../store';

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login');
      } else {
        next();
      }
    });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/home');
      } else {
        next();
      }
    });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/login'));
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: { title: '' }
    },
    {
      path: '/home',
      component: Home,
      beforeEnter: requireAuthenticated,
      meta: { title: 'Products' }
    },/*
    {
      path: '/comparison',
      component: Comparison,
      beforeEnter: requireAuthenticated,
    },*/
    {
      path: '/ordering',
      component: Ordering,
      beforeEnter: requireAuthenticated,
      meta: { title: 'Ordering' }
    },
    {
      path: '/history',
      component: History,
      beforeEnter: requireAuthenticated,
      meta: { title: 'History' }
    },
    {
      path: '/updated_products_barcodes/:updateEntityId',
      component: UpdatedProductsBarcodes,
      beforeEnter: requireAuthenticated,
      meta: { title: 'Barcodes' }
    },
    {
      path: '/ordering_report/:reportEntityId',
      component: OrderingReport,
      beforeEnter: requireAuthenticated,
      meta: { title: 'Ordering Report' }
    },
    /*
    {
      path: '/password_reset',
      component: PasswordReset,
    },
    {
      path: '/password_reset/:uid/:token',
      component: PasswordResetConfirm,
    },
    {
      path: '/register',
      component: Register,
    },
    {
      path: '/register/:key',
      component: VerifyEmail,
    }, */
    {
      path: '/login',
      component: Login,
      beforeEnter: requireUnauthenticated,
      meta: { title: 'Login' }
    },
    {
      path: '/logout',
      beforeEnter: redirectLogout,
    },
    {
      path: '*',
      component: Lost,
    },
  ],
});

const DEFAULT_TITLE = 'Till reporting';

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title ? `${to.meta.title} - ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js